{
    "Accessibility Menu": "Меню за достъпност",
    "Reset settings": "Нулиране на настройките",
    "Close": "Затвори",
    "Content Adjustments": "Настройки на съдържанието",
    "Adjust Font Size": "Настройка на размера на шрифта",
    "Highlight Title": "Открояване на заглавието",
    "Highlight Links": "Открояване на връзките",
    "Readable Font": "Четим шрифт",
    "Color Adjustments": "Настройки на цветовете",
    "Dark Contrast": "Тъмен контраст",
    "Light Contrast": "Светъл контраст",
    "High Contrast": "Висок контраст",
    "High Saturation": "Висока наситеност",
    "Low Saturation": "Ниска наситеност",
    "Monochrome": "Монохромен",
    "Protanopia": "Протанопия",
    "Deuteranopia": "Дейтеранопия",
    "Tritanopia": "Тританопия",
    "Visual & Navigation Aids": "Визуални и навигационни помощи",
    "Additional Tools": "Допълнителни инструменти",
    "Reading Guide": "Ръководство за четене",
    "Stop Animations": "Спри анимациите",
    "Big Cursor": "Голям курсор",
    "Screen Reader": "Екранен четец",
    "Hide Images": "Скрий изображенията",
    "Image Tooltips": "Подсказки за изображения",
    "Page Structure": "Структура на страницата",
    "Super Focus": "Супер фокус",
    "Magnifier": "Лупа",
    "Increase Font Size": "Увеличи размера на шрифта",
    "Decrease Font Size": "Намали размера на шрифта",
    "Letter Spacing": "Разстояние между буквите",
    "Line Height": "Височина на реда",
    "Font Weight": "Дебелина на шрифта",
    "Dyslexia Font": "Шрифт за дислексия",
    "Language": "Език",
    "Open Accessibility Menu": "Отвори меню за достъпност",
    "Accessibility Profiles": "Профили за достъпност",
    "Seizure Safe Profile": "Профил безопасен при гърчове",
    "Stops animations and reduces color saturation.": "Спира анимациите и намалява наситеността на цветовете.",
    "Blind Profile": "Профил за незрящи",
    "Activates the screen reader for auditory navigation.": "Активира екранния четец за звукова навигация.",
    "Visually Impaired Profile": "Профил за слабовиждащи",
    "Enhances contrast and readability for low vision.": "Подобрява контраста и четимостта за слабовиждащи.",
    "ADHD Friendly Profile": "Профил за ADHD",
    "Reduces distractions for better focus.": "Намалява разсейването за по-добра концентрация.",
    "Cognitive & Learning Profile": "Когнитивен и учебен профил",
    "Helpful tools for reading and comprehension.": "Полезни инструменти за четене и разбиране.",
    "Motor Impaired Profile": "Профил при двигателни затруднения",
    "Optimizes the site for keyboard-only navigation.": "Оптимизира сайта за навигация само с клавиатура.",
    "Headings": "Заглавия",
    "Landmarks": "Ориентири",
    "Links": "Връзки",
    "Focus element": "Фокусирай елемент",
    "Visit link": "Отвори връзка"
}